"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Field = require("./formField");
const fastInput_1 = require("./fastInput");
const slowInput_1 = require("./slowInput");
const react_rxk_1 = require("react-rxk");
class TextIcon extends React.PureComponent {
    render() {
        //Quitamos los props que no le pertenecen al FastInput
        //ver https://github.com/facebook/react/issues/7266
        const _a = this.props, { addon, error, readonly, value, label, loading, disableFastInput } = _a, props = __rest(_a, ["addon", "error", "readonly", "value", "label", "loading", "disableFastInput"]);
        const input = disableFastInput ? React.createElement(slowInput_1.SlowInput, Object.assign({}, props, { className: "form-control", value: value || "", disabled: readonly, type: props.type || "text" })) :
            React.createElement(fastInput_1.FastInput, Object.assign({}, props, { className: "form-control", value: value || "", disabled: readonly, type: props.type || "text" }));
        return (addon ?
            React.createElement("div", { className: "input-group" },
                React.createElement("span", { className: "input-group-addon" }, addon),
                input) : input);
    }
}
class TextInputNoRx extends React.PureComponent {
    render() {
        return (React.createElement(Field.FormField, { label: this.props.label, error: this.props.error },
            React.createElement(TextIcon, Object.assign({}, this.props, { placeholder: this.props.loading ? "Cargando..." : this.props.placeholder }))));
    }
}
exports.TextInputNoRx = TextInputNoRx;
exports.Text = react_rxk_1.componentToRx(TextInputNoRx, undefined, undefined, {
    loading: { loading: true },
    error: { ignore: { observable: true, promise: true } }
});
/**Un campo de contraseña */
class Password extends React.PureComponent {
    render() {
        return (React.createElement(exports.Text, { type: "password", error: this.props.error, readonly: this.props.readonly, label: this.props.label, onChange: this.props.onChange, addon: this.props.addon, value: this.props.value }));
    }
}
exports.Password = Password;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/fields/text.js
// module id = 111
// module chunks = 0